import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import WhatsAppWidget from '../../components/ui/WhatsAppWidget';
import NewsletterSubscription from '../../components/ui/NewsletterSubscription';
import FeaturedArticle from './components/FeaturedArticle';
import CategoryFilter from './components/CategoryFilter';
import SearchBar from './components/SearchBar';
import ArticleCard from './components/ArticleCard';
import RelatedArticles from './components/RelatedArticles';
import SocialShare from './components/SocialShare';
import CommentSection from './components/CommentSection';
import Icon from '../../components/AppIcon';

const BlogInsights = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const categories = [
  { id: 'all', name: 'All Articles', icon: 'Grid', count: 24 },
  { id: 'technology', name: 'Technology', icon: 'Code', count: 12 },
  { id: 'business', name: 'Business', icon: 'Briefcase', count: 8 },
  { id: 'motivation', name: 'Motivation', icon: 'Zap', count: 4 }];



  const articles = [
  {
    id: 1,
    title: "Building Scalable Microservices Architecture with Node.js and Docker",
    excerpt: "Learn how to design and implement a robust microservices architecture that scales efficiently using modern containerization technologies and best practices for enterprise applications.",
    category: "Technology",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10af01abc-1768238504170.png",
    imageAlt: "Modern software development workspace showing multiple computer monitors displaying code and architecture diagrams with Docker containers and Node.js logos visible",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Jan 5, 2026",
    readTime: 12,
    views: "2.4K",
    comments: 45
  },
  {
    id: 2,
    title: "The Entrepreneur\'s Guide to Digital Transformation in Africa",
    excerpt: "Discover practical strategies for leveraging digital technologies to transform traditional businesses across African markets, with real case studies from Nigeria, Cameroon, and South Africa.",
    category: "Business",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1478bcc45-1764651525877.png",
    imageAlt: "African business professionals collaborating around modern conference table with laptops and digital tablets displaying business analytics and transformation roadmaps",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Jan 3, 2026",
    readTime: 10,
    views: "3.1K",
    comments: 67
  },
  {
    id: 3,
    title: "From Developer to Tech Leader: My Journey and Lessons Learned",
    excerpt: "Personal insights and actionable advice on transitioning from individual contributor to technical leadership role, including mentorship strategies and team building experiences.",
    category: "Motivation",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e170712-1767099622987.png",
    imageAlt: "Diverse team of software developers collaborating in modern office space with glass walls, standing around whiteboard filled with technical diagrams and project timelines",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 30, 2025",
    readTime: 8,
    views: "1.8K",
    comments: 34
  },
  {
    id: 4,
    title: "Implementing CI/CD Pipelines: A Comprehensive DevOps Tutorial",
    excerpt: "Step-by-step guide to setting up automated continuous integration and deployment pipelines using GitHub Actions, Jenkins, and AWS, with practical examples and troubleshooting tips.",
    category: "Technology",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13c5833f7-1768045962613.png",
    imageAlt: "Computer screen displaying colorful CI/CD pipeline dashboard with automated testing stages, deployment workflows, and green success indicators across multiple environments",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 28, 2025",
    readTime: 15,
    views: "2.9K",
    comments: 52
  },
  {
    id: 5,
    title: "Startup Funding Strategies for African Tech Entrepreneurs",
    excerpt: "Navigate the African startup ecosystem with proven fundraising strategies, investor pitch techniques, and insights into venture capital landscape across Nigeria, Kenya, and South Africa.",
    category: "Business",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_136ebe11f-1764672595819.png",
    imageAlt: "African entrepreneur presenting business pitch to group of investors in modern boardroom with financial projections displayed on large screen and engaged audience taking notes",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 25, 2025",
    readTime: 11,
    views: "4.2K",
    comments: 89
  },
  {
    id: 6,
    title: "Mastering React Performance Optimization Techniques",
    excerpt: "Deep dive into advanced React optimization strategies including code splitting, lazy loading, memoization, and virtual DOM optimization for building lightning-fast web applications.",
    category: "Technology",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e96a65dc-1767722347351.png",
    imageAlt: "Developer's workspace showing React code editor with performance profiling tools, Chrome DevTools open displaying component render times and memory usage graphs",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 22, 2025",
    readTime: 13,
    views: "3.7K",
    comments: 71
  },
  {
    id: 7,
    title: "Building Resilience: Overcoming Challenges in Tech Entrepreneurship",
    excerpt: "Motivational insights and practical strategies for maintaining mental health, managing stress, and building resilience while navigating the demanding world of technology entrepreneurship.",
    category: "Motivation",
    image: "https://images.unsplash.com/photo-1692346187201-a53682207804",
    imageAlt: "Silhouette of person standing on mountain peak at sunrise with arms raised in victory pose, overlooking vast landscape symbolizing achievement and overcoming challenges",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 20, 2025",
    readTime: 7,
    views: "2.1K",
    comments: 43
  },
  {
    id: 8,
    title: "API Design Best Practices: Building RESTful Services That Scale",
    excerpt: "Comprehensive guide to designing robust, scalable RESTful APIs with proper versioning, authentication, rate limiting, and documentation strategies for enterprise-grade applications.",
    category: "Technology",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1370561b4-1767514065478.png",
    imageAlt: "Technical diagram showing RESTful API architecture with multiple endpoints, authentication flows, and data structures displayed on large monitor in modern development environment",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 18, 2025",
    readTime: 14,
    views: "3.3K",
    comments: 58
  },
  {
    id: 9,
    title: "E-commerce Growth Strategies for African Markets",
    excerpt: "Proven tactics for scaling e-commerce businesses across African markets, including payment integration, logistics optimization, and customer acquisition strategies tailored for local contexts.",
    category: "Business",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_162061d0b-1767103031183.png",
    imageAlt: "African woman shopping online using smartphone and laptop with shopping cart interface visible, surrounded by delivered packages in modern home office setting",
    author: {
      name: "Edrian Bass",
      avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
      avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
    },
    publishDate: "Dec 15, 2025",
    readTime: 9,
    views: "2.8K",
    comments: 64
  }];



  const featuredArticle = articles?.[0];

  const relatedArticles = [
  {
    id: 10,
    title: "Understanding Cloud Architecture Patterns",
    category: "Technology",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c069732d-1764757637236.png",
    imageAlt: "Abstract visualization of cloud computing infrastructure with interconnected nodes and data streams flowing through digital network architecture",
    readTime: 10,
    views: "1.9K"
  },
  {
    id: 11,
    title: "Effective Team Management for Remote Teams",
    category: "Business",
    image: "https://images.unsplash.com/photo-1612831455359-970e23a1e4e9",
    imageAlt: "Video conference call showing diverse team members in grid layout on laptop screen, each person in their home office workspace smiling and engaged",
    readTime: 8,
    views: "1.5K"
  },
  {
    id: 12,
    title: "Daily Habits of Successful Developers",
    category: "Motivation",
    image: "https://images.unsplash.com/photo-1652964803882-b582a77dd18d",
    imageAlt: "Morning routine setup showing organized desk with coffee cup, open planner with daily goals, laptop displaying code, and motivational quotes on wall",
    readTime: 6,
    views: "2.2K"
  }];



  const mockComments = [
  {
    id: 1,
    author: {
      name: "Chioma Okafor",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fca82876-1763294352035.png",
      avatarAlt: "Professional African woman with natural hair styled in elegant updo wearing burgundy blazer with warm smile in office environment"
    },
    content: "This article perfectly captures the challenges and opportunities in African tech entrepreneurship. The insights on digital transformation are particularly valuable for businesses looking to scale.",
    timestamp: "2 hours ago",
    likes: 24,
    replies: [
    {
      id: 101,
      author: {
        name: "Edrian Bass",
        avatar: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
        avatarAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur"
      },
      content: "Thank you Chioma! I'm glad the digital transformation insights resonated with you. Feel free to reach out if you'd like to discuss specific implementation strategies for your business.",
      timestamp: "1 hour ago",
      likes: 12
    }]

  },
  {
    id: 2,
    author: {
      name: "Kwame Mensah",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15b7c2755-1763292513499.png",
      avatarAlt: "Young African male professional with short beard wearing white shirt and gray blazer with confident expression in modern office setting"
    },
    content: "The microservices architecture breakdown is excellent. I've been implementing similar patterns in my projects and this article clarified several concepts I was struggling with.",
    timestamp: "5 hours ago",
    likes: 18,
    replies: []
  },
  {
    id: 3,
    author: {
      name: "Amara Nwosu",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c3f1aeb1-1763298919911.png",
      avatarAlt: "African woman with braided hairstyle wearing professional teal blouse with genuine smile in bright office environment with plants in background"
    },
    content: "As someone transitioning from developer to tech lead, the leadership insights in this article are incredibly timely. The mentorship strategies are practical and actionable.",
    timestamp: "1 day ago",
    likes: 31,
    replies: []
  }];



  useEffect(() => {
    let filtered = articles;

    if (activeCategory !== 'all') {
      filtered = filtered?.filter(
        (article) => article?.category?.toLowerCase() === activeCategory
      );
    }

    if (searchQuery?.trim()) {
      filtered = filtered?.filter(
        (article) =>
        article?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        article?.excerpt?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        article?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    }

    setFilteredArticles(filtered);
  }, [activeCategory, searchQuery]);

  const handleReadMore = (article) => {
    setSelectedArticle(article);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <title>Blog Insights - Edrian Bass | Technology, Business & Motivation</title>
        <meta
          name="description"
          content="Explore expert insights on IT engineering, entrepreneurship, and personal development from Edrian Bass. Read articles on technology trends, business strategies, and motivational guidance." />

      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-teal-950 relative overflow-hidden">
        {/* Animated Background Orbs */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-teal-500/20 rounded-full blur-[120px] animate-pulse-slow" />
          <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-500/20 rounded-full blur-[100px] animate-float" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-teal-400/10 rounded-full blur-[80px] animate-pulse" />
        </div>

        <Header />
        <WhatsAppWidget />

        <main className="pt-24 md:pt-28 lg:pt-32 relative z-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
            {/* Hero Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12 md:mb-16">

              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-teal-500/20 to-cyan-500/20 backdrop-blur-xl rounded-full mb-6 border border-teal-500/30">
                <Icon name="BookOpen" size={20} color="#14b8a6" />
                <span className="text-sm font-semibold text-teal-400">Blog & Insights</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold mb-6 bg-gradient-to-r from-white via-teal-200 to-cyan-300 bg-clip-text text-transparent">
                Knowledge Hub
              </h1>
              <p className="text-base md:text-lg lg:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
                Explore expert insights on technology, business strategies, and personal growth
                from an IT engineer, entrepreneur, and creative director.
              </p>
            </motion.div>

            {/* Featured Article */}
            <FeaturedArticle article={featuredArticle} onReadMore={handleReadMore} />

            {/* Main Content Area with Sidebar Layout */}
            <div className="mt-16 md:mt-20 lg:mt-24">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                {/* Main Content Panel */}
                <div className="lg:col-span-8">
                  {/* Search & Filter Panel */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="bg-slate-900/50 backdrop-blur-xl rounded-2xl p-6 md:p-8 border border-teal-500/20 mb-8 shadow-xl shadow-teal-500/10">
                    <CategoryFilter
                      categories={categories}
                      activeCategory={activeCategory}
                      onCategoryChange={setActiveCategory} />

                    <SearchBar
                      searchQuery={searchQuery}
                      onSearchChange={setSearchQuery}
                      resultsCount={filteredArticles?.length} />
                  </motion.div>

                  {/* Articles Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {filteredArticles?.slice(1)?.map((article, index) =>
                    <ArticleCard
                      key={article?.id}
                      article={article}
                      index={index}
                      onReadMore={handleReadMore} />

                    )}
                  </div>

                  {filteredArticles?.length === 0 &&
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="text-center py-20 bg-slate-900/50 backdrop-blur-xl rounded-2xl border border-teal-500/20">

                      <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-teal-500/10 flex items-center justify-center">
                        <Icon name="Search" size={48} color="#14b8a6" />
                      </div>
                      <h3 className="text-2xl font-semibold mb-3 text-white">No Articles Found</h3>
                      <p className="text-slate-400 mb-6">
                        Try adjusting your search or filter criteria
                      </p>
                    </motion.div>
                  }
                </div>

                {/* Sidebar Panel */}
                <div className="lg:col-span-4 space-y-8">
                  {/* Related Articles Panel */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 }}
                    className="bg-slate-900/50 backdrop-blur-xl rounded-2xl p-6 border border-teal-500/20 shadow-xl shadow-teal-500/10 sticky top-24">
                    <RelatedArticles
                      articles={relatedArticles}
                      onArticleClick={handleReadMore} />
                  </motion.div>

                  {/* Newsletter Panel */}
                  <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                    className="bg-gradient-to-br from-teal-500/10 to-cyan-500/10 backdrop-blur-xl rounded-2xl p-6 border border-teal-500/30 shadow-xl shadow-teal-500/10">
                    <NewsletterSubscription />
                  </motion.div>
                </div>
              </div>
            </div>

            {/* Comments Section */}
            {selectedArticle &&
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="mt-16 bg-slate-900/50 backdrop-blur-xl rounded-2xl p-8 border border-teal-500/20 shadow-xl shadow-teal-500/10">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-2xl md:text-3xl font-bold text-white">Engage & Share</h2>
                  <SocialShare article={selectedArticle} />
                </div>
                <CommentSection comments={mockComments} articleId={selectedArticle?.id} />
              </motion.div>
            }
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-slate-950/80 backdrop-blur-xl border-t border-teal-500/20 py-12 relative z-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center shadow-lg shadow-teal-500/50">
                  <Icon name="Zap" size={24} color="white" />
                </div>
                <span className="text-xl font-bold text-white">Edrian Bass</span>
              </div>
              <p className="text-sm text-slate-400 text-center md:text-left">
                © {new Date()?.getFullYear()} Edrian Bass. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-slate-800/50 backdrop-blur-sm flex items-center justify-center hover:bg-teal-500 hover:shadow-lg hover:shadow-teal-500/50 transition-all duration-300 border border-teal-500/20 text-slate-300 hover:text-white"
                  aria-label="Twitter">

                  <Icon name="Twitter" size={18} color="currentColor" />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-slate-800/50 backdrop-blur-sm flex items-center justify-center hover:bg-teal-500 hover:shadow-lg hover:shadow-teal-500/50 transition-all duration-300 border border-teal-500/20 text-slate-300 hover:text-white"
                  aria-label="LinkedIn">

                  <Icon name="Linkedin" size={18} color="currentColor" />
                </a>
                <a
                  href="https://github.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-slate-800/50 backdrop-blur-sm flex items-center justify-center hover:bg-teal-500 hover:shadow-lg hover:shadow-teal-500/50 transition-all duration-300 border border-teal-500/20 text-slate-300 hover:text-white"
                  aria-label="GitHub">

                  <Icon name="Github" size={18} color="currentColor" />
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>);




};

export default BlogInsights;